import {FC, lazy, Suspense} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {DisableSidebar} from '../../_metronic/layout/core'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import JobItem from '../pages/job/JobItem'
import Profile from '../pages/profile'

const PrivateRoutes = () => {
  const JobWrapper = lazy(() => import('../pages/job/JobWrapper'))
  const ResourcePage = lazy(() => import('../pages/resources'))
  const AboutUsPage = lazy(() => import('../pages/about-us'))
  const ContactUsPage = lazy(() => import('../pages/contact-us'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to job after success login/registartion */}
        <Route path='landing/*' element={<Navigate to='/job' />} />
        {/* Pages */}
        <Route path='job' element={<JobWrapper />} />
        <Route path='job/details/:id' element={<JobItem />} />
        <Route path='jobs/filter/:filter' element={<JobWrapper />} />
        <Route path='job/search' element={<JobWrapper />} />
        <Route path='resource' element={<ResourcePage />} />
        <Route path='profile' element={<Profile />} />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}
type Props = {
  children: React.ReactNode
}
const SuspensedView: FC<Props> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return (
    <Suspense fallback={<TopBarProgress />}>
      <DisableSidebar>{children}</DisableSidebar>
    </Suspense>
  )
}

export {PrivateRoutes}
